import type { EditorView } from "prosemirror-view";

// The arrow keys move the caret between an editor and the sections in it. The
// keymap finds a section through the DOM node of the section.
export interface SectionKeys {
  // Put the caret in the section's editor. Returns false when the section
  // shows no editor.
  enter(forward: boolean): boolean;
  // Put the caret in the outer editor, after or before the section.
  exit(forward: boolean): void;
}

const sections = new WeakMap<Element, SectionKeys>();

export function registerSection(dom: HTMLElement, section: SectionKeys): void {
  sections.set(dom, section);
}

// Put the caret in the section at `pos` of `view`.
export function enterSection(view: EditorView, pos: number, forward: boolean): boolean {
  const dom = view.nodeDOM(pos);
  return dom instanceof Element && (sections.get(dom)?.enter(forward) ?? false);
}

// The section whose editor is `view`, if `view` is the editor of a section.
export function sectionOf(view: EditorView): SectionKeys | undefined {
  const dom = view.dom.parentElement?.closest("[data-card-section]");
  return dom ? sections.get(dom) : undefined;
}
